<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader>
						Edition d'une commande #{{ this.$route.params.id }}
						<CBadge v-if="order" class="ml-1" :color="statusColor[order.status]">{{
							statusTranslation[order.status]
						}}</CBadge>
					</CCardHeader>

					<CCardBody>
						<CRow v-if="!order" alignHorizontal="center">
							<CSpinner color="info" />
						</CRow>
						<CContainer fluid v-else>
							<template v-if="order && customerData">
								<!-- change order status -->
								<CRow class="mb-3">
									<CCol col="6">
										<CDropdown
											class="ml-3 d-inline"
											color="primary"
											:toggler-text="statusTranslation[status]">
											<template v-for="(state, key) in modifiableStatus">
												<CDropdownItem @click="status = key" :key="key">{{
													state
												}}</CDropdownItem>
											</template>
										</CDropdown>
										<CButton class="ml-3" @click="updateState" color="success"
											>Mettre à jour le statut</CButton
										>
									</CCol>

									<CCol col="6" class="float-right text-right">
										<router-link to="/orders/new">
											<CButton color="primary">Créer une nouvelle commande</CButton>
										</router-link>
									</CCol>
								</CRow>

								<CRow>
									<!-- left panel -->
									<CCol sm="3">
										<CCard>
											<CCardHeader> Informations sur la commande </CCardHeader>
											<CCardBody>
												<p>
													<span class="font-weight-bold">Statut :</span>
													<CBadge
														v-if="order"
														class="ml-1"
														:color="statusColor[order.status]">
														{{ statusTranslation[order.status] }}</CBadge
													>
												</p>
												<p v-if="order.contactChannel">
													<span class="font-weight-bold">Source :</span>
													{{ contactChannelTranslation[order.contactChannel] }}
												</p>
												<p>
													<span class="font-weight-bold">Date de création :</span>
													{{ $moment(order.createdAt).format('DD/MM/YYYY HH:mm') }}
												</p>
												<p>
													<span class="font-weight-bold">Facture :</span>
													<CButton
														v-if="
															order.status === 'order.paid' ||
															order.status === 'order.complete'
														"
														@click="downloadInvoice()"
														class="btn btn-link py-0"
														><CIcon name="cil-description"
													/></CButton>
													<CIcon class="ml-2" v-else name="cil-ban" />
												</p>
											</CCardBody>
										</CCard>
										<CustomerInfoCard :customer="customerData" :order="order" />
									</CCol>

									<!-- central panel -->
									<CCol sm="9">
										<OrderItemCard
											:order="order"
											:customer="customerData"
											v-on:refresh="refresh" />
										<PaiementListCard :order="order" v-on:refresh="refresh" />
										<internal-note-card
											v-on:new:note="updateNotes"
											:notes="order.orderNotes"
											:order="order" />
									</CCol>
								</CRow>
							</template>
						</CContainer>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>

<script>
	import OrderItemCard from './_components/orderitem-card';
	import CustomerInfoCard from '../../../../components/cards/customer-info-card';
	import PaiementListCard from './_components/PaiementListCard';
	import InternalNoteCard from './_components/internal-note-card';

	export default {
		components: { PaiementListCard, OrderItemCard, CustomerInfoCard, InternalNoteCard },
		data() {
			return {
				order: null,
				cart: null,
				cartIri: null,
				customerData: null,
				status: '',
				modifiableStatus: {
					'order.paused': 'En pause',
					'order.pending': 'En attente de paiement',
					'order.awaiting_delayed_payment': 'En attente de paiement différé',
					'order.admin_authorized': 'Autorisation direction',
					'order.canceled': 'Annulée',
					'order.refund': 'Remboursée',
				},
				statusTranslation: {
					'order.pending': 'En attente de paiement',
					'order.paused': 'En pause',
					'order.awaiting_delayed_payment': 'En attente de paiement différé',
					'order.paid': 'Payée',
					'order.complete': 'Terminée',
					'order.admin_authorized': 'Autorisation direction',
					'order.payment_issue': 'Erreur de paiement',
					'order.canceled': 'Annulée',
					'order.refund': 'Remboursée',
				},
				statusColor: {
					'order.paused': 'warning',
					'order.pending': 'warning',
					'order.awaiting_delayed_payment': 'warning',
					'order.paid': 'success',
					'order.admin_authorized': 'success',
					'order.complete': 'success',
					'order.payment_issue': 'danger',
					'order.canceled': 'danger',
					'order.refund': 'warning',
				},
				contactChannelTranslation: {
					'order.contact_channel.show_room': 'Show-room',
					'order.contact_channel.web': 'Web',
					'order.contact_channel.letter': 'Lettre',
					'order.contact_channel.email': 'Email',
					'order.contact_channel.phone': 'Téléphone',
					'order.contact_channel.dealer': 'Revendeur',
				},
			};
		},

		mounted() {
			this.loadData();
		},

		methods: {
			downloadInvoice() {
				this.$axios
					.get(`/api/orders/${this.$route.params.id}/invoice`, {
						responseType: 'blob',
					})
					.then(response => {
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						let filename = 'Colipays_facture.pdf';
						const disposition = response.headers['content-disposition'];

						if (disposition && disposition.indexOf('attachment') !== -1) {
							const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
							const matches = filenameRegex.exec(disposition);
							if (matches != null && matches[1]) {
								filename = matches[1].replace(/['"]/g, '');
							}
						}

						link.setAttribute('download', filename); //or any other extension
						document.body.appendChild(link);
						link.click();
					})
					.catch(err => {
						this.$toast.error(
							"Une erreur s'est produite lors de la création de la facture, veuillez contacter un administrateur"
						);
					});
			},
			updateState() {
				this.$axios
					.patch(
						this.order['@id'] + '/status',
						{
							status: this.status,
						},
						{
							headers: {
								'Content-Type': 'application/merge-patch+json',
							},
						}
					)
					.then(res => {
						this.$set(this.order, 'archived', res.data['archived']);
						this.$set(this.order, 'status', res.data['status']);
						this.$set(this.order, 'invoicePathName', res.data['invoicePathName']);
						this.$toast.success('Statut mis à jour avec succès !');
					})
					.catch(err => {
						this.status = this.order.status;
						this.$toast.error(err.response.data['hydra:description']);
					});
			},
			loadCartOwner() {
				this.$axios
					.get(this.order.owner['@id'])
					.then(res => {
						this.customerData = res.data;
					})
					.catch(() => this.error);
			},
			loadData() {
				this.$axios
					.get(`/api/orders/${this.$route.params.id}`)
					.then(res => {
						this.order = res.data;

						if (this.order.cart) {
							this.cartIri = this.order.cart['@id'];
						}

						this.status = this.order.status;
						this.loadCartOwner();
					})
					.catch(() => this.error);
			},
			error() {
				this.$toast.error(
					"Une erreur s'est produite lors des données nécessaire à l'affichage de cette page, contactez un administrateur"
				);
			},

			updateNotes(note) {
				this.order['orderNotes'].push(note);
			},

			refresh() {
				this.loadData();
			},
		},
	};
</script>
